import React, { CSSProperties } from 'react';
import { GridColDefExtended, GridValidRowModel } from '@mui/x-data-grid-pro';

interface RenderCardFieldProps<T extends GridValidRowModel> {
  /** Currently running board definition */
  columnDetails: GridColDefExtended<T>;
  /** Row Data */
  row: T;
  /** Render the Header for the Field */
  includeHeader?: boolean;
  /** Styles to apply to the Rendered Field */
  style?: CSSProperties;
  /** Styles to apply to the Rendered Field's Header */
  headerStyle?: CSSProperties;
  renderEditable?: (target: EventTarget & HTMLElement, columnDetails: GridColDefExtended<T>, row: T) => void;
}

/**
 * Component used for rendering the Board column in a mobile format for the Dispatch Card
 */
export default function RenderCardCell<T extends GridValidRowModel>(props: RenderCardFieldProps<T>) {
  const cellClickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    if (props.renderEditable && props.columnDetails.renderEditableCell) {
      props.renderEditable(event.currentTarget, props.columnDetails, props.row);
    }
  };

  return (
    <div
      style={props.style}
      onClick={cellClickHandler}>
      {props.includeHeader && props.columnDetails.renderHeader && (
        <div style={{ ...props.headerStyle, padding: '2px' }}>{props.columnDetails.renderHeader({} as never)}</div>
      )}
      {props.columnDetails.renderCell?.({ row: props.row, colDef: props.columnDetails } as never)}
    </div>
  );
}
